import { render } from "./qtTable.vue?vue&type=template&id=6d6b3b39"
const script = {}

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__